//
//  @file FilesMainDisk.jsx
//  @author Sergii Oryshchenko <sergii.orishchenko@gmail.com>
//  @see https://github.com/os-v/
//
//  Created on 03.06.20.
//  Copyright 2020 Sergii Oryshchenko. All rights reserved.
//  Any usage of this material is strictly forbidden unless prior written permission is obtained from Sergii Oryshchenko <sergii.orishchenko@gmail.com>.
//

import React, { Component } from "react";
import { Grid, Col, Row } from "react-bootstrap";

class FilesMainDisk extends Component
{

    constructor(props)
    {

        super(props);

        this.state = {
        };

    }

    render()
    {
        return (
            <div className="main-content">
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <br/>
                            <br/>
                            <a href="../../../Files/ActiveConnect.apk">Android App</a><br/><br/>
                            <a href="../../../Files/ActiveConnect.ipa">iPhone App</a><br/><br/>
                            <a href="../../../Files/RAInstall.dmg">MacOSX Client</a><br/><br/>
                            <a href="../../../Files/RAInstall.zip">Windows x64 Client</a><br/><br/>
                        </Col>
                    </Row>
                    <hr/>
                </Grid>
            </div>
        );
    }

}

export default FilesMainDisk;
